import { ImageElement } from '../../Element/ImageElement';
import { VideoElement } from '../../Element/VideoElement';
import { TRANSITION_MINIMUM_DURATION } from './Transitions.constants';
import {
  LifeCycleTransition,
  TransitionMoveDirection,
  TransitionRotateDirection,
  TransitionType
} from './Transitions.types';
import { getElementDurationInMs } from '@/libs/playerConfigUtils';

export const getDefaultTransition = (
  selectedElement: ImageElement | VideoElement,
  fps: number,
  type: TransitionType
): LifeCycleTransition => {
  const parentDuration = getElementDurationInMs(selectedElement, fps);
  const duration = parentDuration < TRANSITION_MINIMUM_DURATION ? 0 : TRANSITION_MINIMUM_DURATION;
  if (type === TransitionType.ROTATE) {
    return {
      type: TransitionType.ROTATE,
      properties: {
        duration,
        rotateDirection: TransitionRotateDirection.CLOCKWISE
      }
    };
  }
  if (type === TransitionType.MOVE) {
    return {
      type: TransitionType.MOVE,
      properties: {
        duration,
        moveDirection: TransitionMoveDirection.UP
      }
    };
  }
  return {
    type,
    properties: {
      duration
    }
  };
};
